import { usePerplexityQueryState } from '#pplx/frontend/apps/ask/providers/ask-query-state-provider/hooks/usePerplexityQueryState.js';
import { useCallback, useEffect, useRef } from 'react';
export function useComposerQuote({ isFollowUp, attachments, addAttachment, focusInput, }) {
    const { quote, quoteAttachment, setQuote, followUps } = usePerplexityQueryState();
    const clearQuote = useCallback(() => setQuote(null), [setQuote]);
    const selections = followUps?.selections;
    const previousSelectionCount = useRef(selections?.length ?? 0);
    useEffect(() => {
        const selectionCount = selections?.length ?? 0;
        const isSelectionAdded = selectionCount > previousSelectionCount.current;
        previousSelectionCount.current = selectionCount;
        if (!quote)
            return;
        // Anchored follow-ups only focus when a passage is added, so removing or
        // hovering a chip doesn't steal focus.
        if (isSelectionAdded || !selections?.some((item) => item.anchor)) {
            focusInput();
        }
    }, [quote, selections, focusInput]);
    const appliedAttachment = useRef(undefined);
    useEffect(() => {
        if (!isFollowUp || quoteAttachment === appliedAttachment.current) {
            return;
        }
        appliedAttachment.current = quoteAttachment;
        if (quoteAttachment && !attachments?.some(({ url }) => url === quoteAttachment.url)) {
            addAttachment(quoteAttachment);
        }
    }, [isFollowUp, quoteAttachment, attachments, addAttachment]);
    return { quote, clearQuote };
}
//# sourceMappingURL=useComposerQuote.js.map